// extracted by mini-css-extract-plugin
export var mobileRightSpacer = "styles-module__mobileRightSpacer___aVRV5";
export var rightContainer = "styles-module__rightContainer___RhQ3K";